import { useState } from "react";
import { Chip, Group, Stack, Text } from "@mantine/core";
import { SUBJECT_BUILDER_FIELDS } from "./subjectBuilderCatalog";

/**
 * Click-together subject builder rendered as chip groups — one row per catalog
 * field, single-pick per field. Emits the composed prompt string on every
 * change. Fully optional: an empty builder contributes nothing.
 */
export default function SubjectBuilder({ onChange }) {
  const [selections, setSelections] = useState({});

  const pick = (fieldId, value) => {
    setSelections((prev) => {
      // Clicking the active chip clears the field (toggle semantics).
      const next = { ...prev, [fieldId]: prev[fieldId] === value ? undefined : value };
      onChange?.(next);
      return next;
    });
  };

  return (
    <Stack gap={6}>
      {SUBJECT_BUILDER_FIELDS.map((field) => (
        <div key={field.id}>
          <Text size="xs" fw={500} c="dimmed" mb={4}>
            {field.label}
          </Text>
          <Group gap={5} wrap="wrap">
            {field.options.map((opt) => (
              <Chip
                key={opt.value}
                size="xs"
                checked={selections[field.id] === opt.value}
                onChange={() => pick(field.id, opt.value)}
              >
                {opt.label}
              </Chip>
            ))}
          </Group>
        </div>
      ))}
    </Stack>
  );
}
